import React, { useState } from "react";
import { useFormik } from "formik";
import google from "../Assets/imgs/google.webp";
import { Spinner } from "react-bootstrap";

interface LoginProps {
  errorMessage: string;
  isLoading: boolean;
  onLoginPressed: (value: { email: string; password: string }) => void;
  updateErrorMessage: (error?: any) => void;
  onPressgoogleLogin: () => void;
}

const passwordGuideline =
  "Password must be 8-40 characters, include at least one uppercase letter, one lowercase letter, and one number.";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,40}$/;

const validate = (values: { email: string; password: string }) => {
  const errors: { email?: string; password?: string } = {};
  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.password) {
    errors.password = "Password is required";
  }
  return errors;
};

const Login: React.FC<LoginProps> = (props) => {
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      props.updateErrorMessage("");
      props.onLoginPressed(values);
    },
  });
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="__login">
      <div className="login-Wraper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="__form">
                <div className="heading">LOG IN</div>
                <div className="loginaccount">Log in to your account</div>
                <div className="blue__line"></div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="inputField">
                    <label htmlFor="email">Email</label>
                    <input
                      id="email"
                      name="email"
                      type="text"
                      value={formik.values.email}
                      onChange={(e) => {
                        formik.handleChange(e);
                        props.updateErrorMessage("");
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="error">
                        {formik.errors.email}
                      </div>
                    ) : null}
                  </div>
                  <div className="inputField">
                    <label htmlFor="password">Password</label>
                    <div className="passwordParent">
                      <input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        value={formik.values.password}
                        onChange={(e) => {
                          formik.handleChange(e);
                          props.updateErrorMessage("");
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <div
                        className="watchPassword"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i
                          className={
                            showPassword ? "ri-eye-off-line" : "ri-eye-line"
                          }
                        ></i>
                      </div>
                    </div>
                    {(formik.touched.password || formik.submitCount > 0) &&
                    formik.errors.password ? (
                      <div className="error">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>
                  <div className="error">
                    {props.errorMessage}
                  </div>
                  <div className="remember_forgot flex">
                    <div className="flex-gap">
                      {/* <input type="checkbox" /> */}
                      {/* <span>Remember Me</span> */}
                    </div>
                    <a href="forgotpassword" className="forgot__password">
                      Forgot Password
                    </a>
                  </div>
                  <div className="login_btn">
                    <button type="submit">
                      {props.isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Log in"
                      )}
                    </button>
                  </div>
                </form>
                <div className="OR">
                  <span className="loginwith">OR Log in with</span>
                </div>
                <div className="loginGoogle">
                  <button onClick={props.onPressgoogleLogin}>
                    <span>
                      <img src={google} alt="google" className="googleImg" />
                    </span>
                    Log in with google
                  </button>
                </div>
                <div className="dontAccount">
                  Don't have an account? <a href="signup">Sign Up</a>{" "}
                </div>
              </div>
            </div>
            <div className="col-lg-6 mobileBG">
              <div className="loginRightSide">
                <div className="welconeText">WELCOME TO </div>
                <div className="myCheckList">QualiCheck</div>
                <div className="loginDesc">
                  Your digital checklist and operational-assurance
                  platform—structured, traceable and ready to support your
                  operations.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
